module.exports = __webpack_public_path__ + "static/media/236-tajikistan.38bef75f.svg";